export const setURLParams = (query: string) => {
  const path = window.location.pathname;
  const params = new URLSearchParams(query);

  const state = query ? `${path}?${params.toString()}` : path;
  window.history.replaceState({}, '', state);
};

export const applyFilter = (query: string, clean = true) => {
  document.dispatchEvent(new CustomEvent('filter:change', { detail: { query, clean } }));
};

export const updateQuery = (form: HTMLFormElement) => {
  const formData = new FormData(form);
  const params = new URLSearchParams(formData as any);

  applyFilter(params.toString());
};

export const resetFilter = (form: HTMLFormElement) => {
  const checkboxes = form.querySelectorAll<HTMLInputElement>('input:checked');

  checkboxes.forEach((input) => {
    input.checked = false;
  });

  document.dispatchEvent(new Event('filter:reset'));
};

export default {
  updateQuery,
};
